// extracted by mini-css-extract-plugin
export default {"content":"styles__content___noaIt mixins__clearfix___YpR0o","leftColumn":"styles__leftColumn___WM4UL","rightColumn":"styles__rightColumn___0dPJm"};